import { render, staticRenderFns } from "./AgregaReferencia.vue?vue&type=template&id=86fd7c80"
import script from "./AgregaReferencia.vue?vue&type=script&lang=js"
export * from "./AgregaReferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports